import type { ComponentPropsWithRef } from "react";
import { useImageSrc } from "../../hooks/useImageSrc";

type Props = Omit<ComponentPropsWithRef<"img">, "src"> & {
  src?: string | null;
  /** The file's type when known (wins over the URL's extension; needed for blob: previews). */
  mime?: string | null;
};

/** An <img> that also shows HEIC/HEIF on browsers without native support (see lib/heicImage). */
export default function Img({ src, mime, ...rest }: Props) {
  const shown = useImageSrc(src, mime);
  return <img {...rest} src={shown} />;
}
